import React from 'react';
//scss
import './ProjectA.scss';
//icons
import Sphinx from '../Icons/sphinx';

class ProjectA extends React.Component {
  constructor() {
    super();
    this.backgroundRef = React.createRef();
    this.underlineRef = React.createRef();
  }

  onHoverOn = () => {
    const isFirefox = typeof InstallTrigger !== 'undefined';
    if (isFirefox === false) {
      const background = this.backgroundRef.current;
      background.classList.toggle('background_hover');
    }
    const underline = this.underlineRef.current;
    underline.classList.toggle('underline_hover');
  };

  onHoverOut = () => {
    const isFirefox = typeof InstallTrigger !== 'undefined';
    if (isFirefox === false) {
      const background = this.backgroundRef.current;
      background.classList.toggle('background_hover');
    }
    const underline = this.underlineRef.current;
    underline.classList.toggle('underline_hover');
  };

  render() {
    return (
      <div className="ProjectA" name="Projects">
        <div className="ProjectA_background" ref={this.backgroundRef}></div>
        <div
          className="ProjectA_content"
          onMouseEnter={this.onHoverOn}
          onMouseLeave={this.onHoverOut}
        >
          <div className="ProjectA_Text">
            <div className="ProjectA_Text_title">
              SPHINX
              <div
                className="ProjectA_Text_title_underline"
                ref={this.underlineRef}
              ></div>
            </div>
            <div className="ProjectA_Text_description">
              Post geotagged media messages to public and private channels,
              viewable only within a local radius <span>(OFFLINE)</span>
            </div>
          </div>
          <Sphinx />
        </div>
      </div>
    );
  }
}

export default ProjectA;
